// extracted by mini-css-extract-plugin
export default {"footer":"MainFooter_footer__JyUCh","limiter":"MainFooter_limiter__tuoNJ","logoWrapper":"MainFooter_logoWrapper__E2Pcx","contents":"MainFooter_contents__LwJJb"};